import { ChevronDownIcon } from '@chakra-ui/icons'
import { Box, Button, Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react'
import { usePdfView } from '../../PdfView/context'

export const PageSelect = ({
  pageIndex,
  setPageIndex,
}: {
  pageIndex: number
  setPageIndex: (index: number) => void
}) => {
  const { numPages } = usePdfView()
  return (
    <Box ml={1.5}>
      <Menu size="sm" strategy="fixed" placement="bottom-start">
        <MenuButton variant="ghost" size="xs" as={Button} rightIcon={<ChevronDownIcon />}>
          TO PAGE {pageIndex + 1}
        </MenuButton>
        <Portal>
          <MenuList
            w="100px"
            minW="0"
            bg="gray.50"
            boxShadow="0 0 4px #00000066"
            border="1px solid #cdcdcd"
            borderRadius={6}
            p={0}>
            {Array.from({ length: numPages ?? 0 }).map((_, i) => (
              <MenuItem
                bg="transparent"
                py={1}
                px={2}
                borderTop={i === 0 ? 'none' : '1px solid #cdcdcd'}
                _hover={{ bg: 'whiteAlpha.500' }}
                fontSize="sm"
                key={i}
                onClick={() => setPageIndex(i)}>
                Page {i + 1}
              </MenuItem>
            ))}
          </MenuList>
        </Portal>
      </Menu>
    </Box>
  )
}
